module.exports = __webpack_public_path__ + "static/media/201_SHOT_341.eacf6c52.webp";